/**
 * Created by jv on 10/03/2017.
 */
// Styles
require("Libs/fontawesome/font-awesome.css");
require("cookieconsent/build/cookieconsent.min.css");
require("Libs/custom-scrollbar/jquery.mCustomScrollbar.css");

// js
require("script-loader!Sources/misc/google-analytics");
require("babel-polyfill");
// Polyfill promises
require("es6-promise/auto");
require("Libs/bootstrap/js/index.umd");
// These libs aren't nice and put themselves in window instead of being able to be required into a variable
// prepend the JS files with 'script-loader?' to require them like they were added with ordinary <script> tags
// https://webpack.github.io/docs/shimming-modules.html
require("script-loader?Modernizr!Libs/Modernizr/modernizr-custom"); // Is used to check if browser is outdated
require("script-loader!cookieconsent/build/cookieconsent.min"); // requires the cookieconsent library like it was a script tag in the html
require("script-loader!Libs/custom-scrollbar/jquery.mCustomScrollbar.concat.min");

// Dark mode favicon
let faviconDark = require("Images/favicon_white.png")

// Global app styles (after external libs)
require("Styles/global.scss");

const log = require("Sources/utils/logger")();
import LanguageManager from "Sources/services/language-manager";
import UserServices from "Sources/services/user-services";
import FormUtils from "Sources/utils/form-utils";
import utils from "Sources/utils/utils";
import Dialog from "Sources/utils/modal";

import AccountIcon from "!raw-loader!Images/icons/teacher-platform/icon_account.svg";

let Shared = {};

((Shared) =>
{
    Shared.init = function()
    {
        if (Shared.isOutdated())
        {
            log.info("Browser is outdated, redirecting to /outdated");
      utils.redirect("/outdated");
    }

    let userData = Shared.getUserData();

    if(utils.isNotNull(userData))
    {
      log.info("User: %o", userData);
    }

    if(__DEVELOPMENT__)
    {

    }
    else
    {
      if(utils.isNotNull(userData))
      {
        // ga("set", "userId", userData.userKey);
        // ga("set", "dimension1", userData.userKey);
      }

      // ga("send", "pageview");
    }

        setUpMatchMedia();

        // Set default nav link highlight (try to find it based on current path
        Shared.setNavHighlight();

        setUpFragmentImages();

        LanguageManager.init();

        const urlParams = new URLSearchParams(window.location.search);
        const queryParamLocale = urlParams.get("l");

        if (LanguageManager.localeExists(queryParamLocale))
        {
            localStorage.setItem("teacher_locale", queryParamLocale);
        }

        const savedTeacherLocale = localStorage.getItem("teacher_locale");

        if (utils.isNotNull(userData) && utils.isNotNull(userData.locale))
        {
            console.log(`Trying to set locale from logged in user: ${userData.locale}`);
            LanguageManager.changeLocale(userData.locale);
        }
        else if (savedTeacherLocale !== null)
        {
            console.log(`Trying to set locale from saved setting: ${savedTeacherLocale}`);
            LanguageManager.changeLocale(savedTeacherLocale);
        }
    };

  LanguageManager.onInitGlobal = function()
  {
    // Needs to be done after localization has been applied
      setUpProfileTooltip();
      setUpLanguageSelector();

    try
    {
      cookieconsent.initialise({
        palette: {
          popup: {
            background: "#222222",
            text: "#ffffff"
          },
          button: {
            background: "#679CD3",
            text: "#ffffff"
          }
        },
        theme: "classic",
        content: {
          message: LanguageManager.getValueForKey("cookies.message"),
          dismiss: LanguageManager.getValueForKey("cookies.button.text"),
          link: LanguageManager.getValueForKey("cookies.link.text"),
          href: LanguageManager.getValueForKey("cookies.link")
        }
      });
    }
    catch(e)
    {
      console.error(e);
    }
  };

  Shared.setNavHighlight = function(href)
  {
    href = utils.isNotNull(href) ? href : utils.getUrlPath();

    $("header .navbar-nav .nav-item a.nav-link").each((index, el) =>
    {
      let $el = $(el);
      let navLink = $el.attr("href"),
          alternatives = $el.data("link-alternatives");

      if(href === navLink || (utils.isNotNull(alternatives) && alternatives.split(";").includes(href)))
      {
        $el.addClass("active");
      }
    });

    $("header .navbar-nav .nav-item a.nav-link[href='" + href + "']").addClass("active");
  };

  Shared.isOutdated = function()
  {
    return !Modernizr.filereader;
  };

  Shared.getUserData = function()
  {
    let userData = $("#logged-in-user-data").attr("data-user");
    if(utils.isNotNull(userData))
    {
      userData = decodeURIComponent(userData);

      if(utils.isNotNull(userData))
      {
        userData = utils.parseJSON(userData, true);
      }
    }
    return userData;
  };

  Shared.isLoggedIn = function()
  {
    return utils.isNotNull(Shared.getUserData());
  };

  function setUpFragmentImages()
  {
    let headerLogo = require("Images/header/ecoceo-logo.svg");
    // let footerLogo = require("Images/footer/cartamundi-logo.png");

      $(".header-ecoceo-brand").append("<img src='" + headerLogo + "' alt='EcoCEO'/>");
      $(".header-ecoceo-user").append(`${AccountIcon}`);
    // $("#footer-main-logo").append("<img src='" + footerLogo + "'/>");
  }

  function setUpMatchMedia()
  {
    // Matches the favicon to the current preferred color scheme

    if(!utils.isFunction(window.matchMedia))
    {
      return;
    }

    const faviconDarkLink = document.createElement("link");
    faviconDarkLink.setAttribute("rel", "favicon icon");
    faviconDarkLink.setAttribute("type", "image/png");
    faviconDarkLink.setAttribute("media", "(prefers-color-scheme:dark)");
    faviconDarkLink.setAttribute("href", faviconDark);
    document.head.appendChild(faviconDarkLink);

    const links = collectLinks();

    let current = document.createElement("link");
    current.setAttribute("rel", "shortcut icon");
    document.head.appendChild(current);

    function faviconApplyLoop()
    {
      links.forEach(function(link) {
        if(window.matchMedia(link.media).matches)
        {
          current.setAttribute("type", link.getAttribute("type"));
          current.setAttribute("href", link.getAttribute("href"));
        }
      })
    }

    faviconApplyLoop();
    links.forEach(function(link)
    {
      document.head.removeChild(link);
    });

    let lightMediaMatch = window.matchMedia("(prefers-color-scheme:light)");
    let darkMediaMatch = window.matchMedia("(prefers-color-scheme:dark)");

    if(utils.isFunction(lightMediaMatch.addEventListener))
    {
      /*
        This is basically an alias for EventTarget.addEventListener(), for backwards compatibility purposes.
        Older browsers should use addListener instead of addEventListener since MediaQueryList only inherits from EventTarget in newer browsers.
      */

      lightMediaMatch.addEventListener("change", function(e)
      {
        if(!e.matches) return;
        faviconApplyLoop();
      });

      darkMediaMatch.addEventListener("change", function(e)
      {
        if(!e.matches) return;
        faviconApplyLoop();
      });
    }
    else
    {
      // noinspection JSDeprecatedSymbols
      lightMediaMatch.addListener(function(e)
      {
        if(!e.matches) return;
        faviconApplyLoop();
      });

      // noinspection JSDeprecatedSymbols
      darkMediaMatch.addListener(function(e)
      {
        if(!e.matches) return;
        faviconApplyLoop();
      });
    }
  }

  function collectLinks()
  {
    return Array.prototype.slice.apply(document.head.querySelectorAll("link[rel*='icon']"));
  }

  function setUpProfileTooltip()
  {
    let $trigger = $("[data-nav-trigger='tooltip']");
    let $popoverContent = $trigger.next();
    $popoverContent = $($popoverContent.prop("outerHTML")).css("display", "").prop("outerHTML");

    $trigger.popover({
      content: $popoverContent,
      html: true,
      template: "<div class='popover popover-c-primary user-profile-popover' role='tooltip'><div class='popover-arrow'></div><div class='popover-body'></div></div>"
    });

      /*$trigger.on("hide.bs.popover", (e) =>
      {
        let $this = $(e.currentTarget);
        let $popover = $(".user-profile-popover");
        if(($popover.length && $popover.is(":hover")) || ($this.length && $this.is(":hover")))
        {
          log.info("HOVERING");
          e.preventDefault();
        }
      });*/
  }

    function setUpLanguageSelector()
    {
        const loggedInUser = Shared.getUserData();

        const selectize = FormUtils.setUpSelectize("#header-locale-selection", [
            { value: "bs-BA", text: LanguageManager.getValueForKey("language.bs-BA") },
            { value: "cs-CZ", text: LanguageManager.getValueForKey("language.cs-CZ") },
            { value: "de-DE", text: LanguageManager.getValueForKey("language.de-DE") },
            { value: "et-EE", text: LanguageManager.getValueForKey("language.et-EE") },
            { value: "en-GB", text: LanguageManager.getValueForKey("language.en-GB"), default: true },
            { value: "es-ES", text: LanguageManager.getValueForKey("language.es-ES") },
            { value: "fr-FR", text: LanguageManager.getValueForKey("language.fr-FR") },
            { value: "hr-HR", text: LanguageManager.getValueForKey("language.hr-HR") },
            { value: "it-IT", text: LanguageManager.getValueForKey("language.it-IT") },
            { value: "lv-LV", text: LanguageManager.getValueForKey("language.lv-LV") },
            { value: "hu-HU", text: LanguageManager.getValueForKey("language.hu-HU") },
            { value: "nl-BE", text: LanguageManager.getValueForKey("language.nl-BE") },
            { value: "pl-PL", text: LanguageManager.getValueForKey("language.pl-PL") },
            { value: "pt-PT", text: LanguageManager.getValueForKey("language.pt-PT") },
            { value: "sl-SI", text: LanguageManager.getValueForKey("language.sl-SI") },
            { value: "sk-SK", text: LanguageManager.getValueForKey("language.sk-SK") },
            { value: "fi-FI", text: LanguageManager.getValueForKey("language.fi-FI") },
            { value: "sv-SE", text: LanguageManager.getValueForKey("language.sv-SE") },
            { value: "el-GR", text: LanguageManager.getValueForKey("language.el-GR") },
            { value: "sr-RS", text: LanguageManager.getValueForKey("language.sr-RS") },
            { value: "ja-JP", text: LanguageManager.getValueForKey("language.ja-JP") }
        ]);

        if (selectize && utils.isNotNull(loggedInUser))
        {
            selectize.setValue(loggedInUser.locale || "en-GB", true);
        }
        else if (selectize && localStorage.getItem("teacher_locale") !== null)
        {
            selectize.setValue(localStorage.getItem("teacher_locale") || "en-GB", true);
        }

        $("#header-locale-selection").off("change").on("change", function(e)
        {
            const $el = $(this);
            const locale = $el.val();

            // Update the current language
            LanguageManager.changeLocale(locale);
            localStorage.setItem("teacher_locale", locale);

            // Update user profile if logged in
            const loggedInUser = Shared.getUserData();
            if (utils.isNull(loggedInUser))
            {
                return;
            }

            const userKey = loggedInUser.userKey;

            UserServices.updateLocale(userKey, locale);
        });
    }

    Shared.Dialog = Dialog;

    return Shared;
})(Shared);

module.exports = Shared;



// WEBPACK FOOTER //
// ./app/js/shared.js